import { useContext } from 'react';
import styled from 'styled-components';
import { Box } from 'foundations-components/transitional/components/Box';
import { Flex } from 'foundations-components/components/Flex';
import { SectionContext } from '../../context/SectionContext';
import ImageFormatter from '../../components/image/ImageFormatter';
import { jsx as _jsx } from "react/jsx-runtime";
const TwoColumnBox = styled.div.withConfig({
  displayName: "ImageGridSectionFormatter__TwoColumnBox"
})(["flex-basis:256px;"]);
const ImageGridSectioFormatter = ({
  section,
  callbacks
}) => {
  var _callbacks$IMAGE_GRID;
  const {
    layoutSize
  } = useContext(SectionContext);
  const onImageClick = callbacks === null || callbacks === void 0 || (_callbacks$IMAGE_GRID = callbacks.IMAGE_GRID) === null || _callbacks$IMAGE_GRID === void 0 ? void 0 : _callbacks$IMAGE_GRID.onImageClick;
  const shouldUseModal = Boolean(onImageClick);
  if (layoutSize === 'SM') {
    return /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      gap: "500",
      children: section.contents.map((imageDefinition, index) => /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx(ImageFormatter, {
          alt: imageDefinition.alt,
          onImageClick: onImageClick,
          showLightbox: false,
          src: imageDefinition.url
        })
      }, index))
    });
  }
  return /*#__PURE__*/_jsx(Flex, {
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "500",
    maxInlineSize: "532px",
    children: section.contents.map((imageDefinition, index) => /*#__PURE__*/_jsx(TwoColumnBox, {
      children: /*#__PURE__*/_jsx(ImageFormatter, {
        alt: imageDefinition.alt,
        onImageClick: onImageClick,
        showLightbox: !shouldUseModal,
        src: imageDefinition.url
      })
    }, index))
  });
};
export default ImageGridSectioFormatter;